import { Int } from '@adornis/baseql/baseqlTypes.js';
import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { abacOperationMiddleware } from '../../permissions/middlewares/abacOperationMiddleware.js';
import { UserListActions } from '../../users/list/UserListPolicy.js';
import { StudentExitOptions } from '../entities/StudentExitOptions.js';
import { resolveStudentExit } from '../server/resolveStudentExit.js';

// the same action guards both buttons that open the assistant
const executeStudentExit = registerMutation({
  type: () => Int,
  operationName: 'executeStudentExit',
  params: [{ type: () => StudentExitOptions, name: 'options' }],
  middlewares: [abacOperationMiddleware(UserListActions.USER_LIST_BOOKINGS_EDIT)],
  resolve: resolveStudentExit,
});

export const AustrittAPI = {
  execute: executeStudentExit,
};
